import { nanoid } from "nanoid";
import React, { useEffect, useState, startTransition } from "react";
import classes from "./CascadingList.module.css";

/*
 *
 * Created on Thu 12 May 2023
 *
 * Copyright (c) 2023 One97 communications
 * @author poonam.chandra
 * @modified By :
 *
 */

const CascadingList = ({
  title,
  data,
  hasFaq = false,
  activeSection = null,
}) => {
  const [activeTab, setActiveTab] = useState(activeSection);

  const handleClick = (e, itemId) => {
    startTransition(() => {
      if (activeSection === null)
        setActiveTab(itemId === activeTab ? null : itemId);
      const element = document.getElementById(itemId);
      if (element) {
        const padding = 80;
        const elementTop = element.getBoundingClientRect().top + window.scrollY;
        const scrollToPosition = elementTop - padding;
        window.scrollTo({ top: scrollToPosition, behavior: "smooth" });
      }
    });
    e.stopPropagation();
  };

  useEffect(() => {
    setActiveTab(activeSection);
  }, [activeSection]);

  const renderList = list => {
    return (
      <ul className={classes.cascadingList}>
        {list.map(item => (
          <li
            key={nanoid()}
            className={activeTab === item.id ? classes.active : ""}
            onClick={e => handleClick(e, item.id)}
            id={item.id}
          >
            <div>{item.title}</div>
            {item.children && (
              <>
                <ul className={classes.cascadingList}>
                  {item.children.map(item => (
                    <li key={nanoid()} id={item.id}>
                      <div>{item.title}</div>
                    </li>
                  ))}
                </ul>
              </>
            )}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div className={classes.container}>
      <div className={classes.heading}>{title}</div>
      <div>
        <ul className={classes.cascadingList}>
          {renderList(data)}
          {hasFaq && (
            <li
              key={nanoid()}
              className={activeTab === "faqData" ? classes.active : ""}
              onClick={e => handleClick(e, "faqData")}
              id="faqData"
            >
              <div>FAQ</div>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default CascadingList;
